/*
Author: Liubo
Date: 2018-11-27
Desc: 框架和项目公用方法
*/
import util from "./util";
import utilJfit from "./util_jfit";

export default Object.assign(util, utilJfit);
